module.exports = __webpack_public_path__ + "static/media/final.78b58d6e.svg";